export enum FootnoteHint {
  NedcEngineDisclaimer = 1,
  WltpEngineDisclaimer = 2,
  DefaultEngineDisclaimer = 3,
  HybridPerformance = 4,
  EfficencyDisclaimer = 5,
  SaveConfigMme = 7,
  FinanceProvider = 6,
  EnvironmentalBonus = 8,
  PriceDisplayB2B = 9,
  PriceDisplayB2C = 10,
  ContactDealerForms = 11,
  RRPrice = 12
}
